module.exports = __webpack_public_path__ + "1f1de48bc8b7fcb209afa7a17560a1e9.pdf";